import React, { useState } from "react";
import PostPopup from "../common/PostPopup";
import { FaEye, FaHeart, FaShareAlt } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BsChatSquareDotsFill } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa6";
import shareIcon from "../../assets/images/icons/shareIcon.svg";
import ShareModal from "../ShareModal";
import PostEditModal from "../feedpost/PostEditModal";
import { BsThreeDots } from "react-icons/bs"; // ✅ horizontal dots
import { formatDateTime } from "../../utils/date";

const APP_BASE_URL = (process.env.REACT_APP_APP_BASE_URL || "").replace(/\/$/, "");
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function PostCard({ post, profiledate }) {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentPostUrl, setCurrentPostUrl] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const handleShareClick = (shareUrl) => {
    setCurrentPostUrl(shareUrl || `${APP_BASE_URL || window.location.origin}${window.location.pathname}${window.location.search}`); // Fallback to page URL
    setIsShareModalOpen(true);
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [comments, setComments] = useState([]);
  // Fetch post by ID (your existing function)
  const fetchPostById = async (postId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-post-by-id?id=${postId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token,
          },
        }
      );
      const data = await response.json();
      if (data.success && data.result) {
        setSelectedPost(data.result);
        setSelectedPostId(data.result.id);
      }
    } catch (err) {
      console.error("Error fetching post:", err);
    }
  };
  const fetchComments = async (postId) => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const res = await fetch(
        `${API_BASE_URL}/comment/get-comments`,
        {
          method: "POST", // ✅ use POST instead of GET
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: {
              post_id: String(postId), // ✅ body must include post_id as string
            },
            page: 1,
            limit: 20, // optional pagination
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setComments(data.result.comments);
      } else {
        console.error("❌ Failed to fetch comments:", data.message);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
    }
  };
  const openPopup = (post) => {
    setSelectedPostId(post.id);
    setIsPopupOpen(true);
    fetchPostById(post.id);
    fetchComments(post.id);
  };
  // Edit handler (open modal, pre-fill data, call edit API)
  const handleEditPost = async () => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      const payload = {
        post_id: post.id,
        user_id: post.user_id,
        content: post.content || "",
        media_url: post.media_url || [],
        is_donation: post.is_donation || false,
        start_date: post.start_date || null,
        end_date: post.end_date || null,
        category: post.category_id || null,
        donation_target: post.donation_target || null,
        title: post.title || null,
        isPublic: post.isPublic,
        share_text: post.share_text,
        is_seller_post: post.is_seller_post ? "true" : "false",
        seller_id: profiledate?.id?.toString(),
        product_url: post.product_url || "",
      };

      await fetch(`${API_BASE_URL}/post/edit-post`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify(payload),
      });

      alert("✅ Post updated successfully");
      window.location.reload();
    } catch (err) {
      console.error("❌ Error editing post:", err);
      alert("Failed to edit post");
    }
  };

  // Delete handler
  const handleDeletePost = async () => {
    const confirmDelete = window.confirm(
      "🗑️ Are you sure you want to delete this post?"
    );
    if (!confirmDelete) return;
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      const payload = {
        post_id: post.id,
        media_url: post.media_url || [],
        is_deleted: true, // ✅ mark as deleted
      };

      await fetch(`${API_BASE_URL}/post/edit-post`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify(payload),
      });
      alert("🗑️ Post deleted successfully");
      window.location.reload();
    } catch (err) {
      console.error("❌ Error deleting post:", err);
      alert("Failed to delete post");
    }
  };

  return (
    <div className=" mt-10 max-w-xl  bg-[#FFFEEB] rounded-xl p-4 shadow-md space-y-4 border border-[#ccc]">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <button
            onClick={() => openPopup(post)}
            className="flex items-center gap-2"
          >
            <img
              src={
                profiledate?.profile_image?.url || require("../../assets/profile.png")
              }
              alt="profile"
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="text-left">
              <p className="font-semibold text-sm">
                {" "}
                {profiledate?.name || "Unknown User"}
              </p>
              <p className="text-xs text-gray-500">
                {" "}
                {formatDateTime(post?.created_at)}
              </p>
            </div>
          </button>
        </div>
        <div className="relative">
          {/* <button
            className="text-gray-400 text-xl font-bold"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <BsThreeDotsVertical />
          </button> */}

          {/* Three Dots Menu */}
          <button
            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 text-gray-600 hover:bg-gray-300"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <BsThreeDots size={18} /> {/* ✅ Horizontal dots inside circle */}
          </button>
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-32 bg-white shadow-lg rounded-lg border z-50">
              <button
                className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                onClick={() => {
                  setIsEditOpen(true);
                  setMenuOpen(false);
                }}
              >
                Edit
              </button>
              <button
                className="block w-full px-4 py-2 text-left text-sm hover:bg-gray-100 text-red-600"
                onClick={handleDeletePost}
              >
                Delete
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Content */}
      {post?.content && (
        <button
          onClick={() => openPopup(post)}
          className="text-left w-full mt-2"
        >
          <p className="text-gray-700 text-sm">{post.content}</p>
        </button>
      )}
      {/* <div className="flex flex-wrap gap-2">
        {["#lifestyle2025", "#newyear2025", "#2025"].map((tag, idx) => (
          <span
            key={idx}
            className="bg-[#d5f7e4] text-green-800 text-xs font-medium px-3 py-1 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div> */}
      {/* Tags */}
      {post?.tags?.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {post.tags.map((tag, idx) => (
            <span
              key={idx}
              className="bg-[#d5f7e4] text-green-800 text-xs font-medium px-3 py-1 rounded-full"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
      {/* <div className="flex gap-4 overflow-x-auto  ">
        {[
          "/image/indidvilesell.png",
          "/image/indidvilesell.png",
          "/image/indidvilesell.png",
        ].map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`gallery-${idx}`}
            className="w-32 h-32 border-2 rounded-lg object-cover flex-shrink-0"
          />
        ))}
      </div> */}
      {/* Media */}
      {post?.media_url?.length > 0 && (
        <div className="flex gap-4 overflow-x-auto">
          <button onClick={() => openPopup(post)} className="">
            {post.media_url.map((media, idx) =>
              media.media_type === "video" ? (
                <video
                  key={idx}
                  src={media.url}
                  controls
                  className="w-32 h-32 border-2 rounded-lg object-cover flex-shrink-0"
                />
              ) : (
                <img
                  key={idx}
                  src={media.url}
                  alt={`gallery-${idx}`}
                  className="w-32 h-32 border-2 rounded-lg object-cover flex-shrink-0"
                />
              )
            )}
          </button>
        </div>
      )}
      {/* ✅ Product Section (only for seller posts) */}
      {post?.is_seller_post && post?.product_url && (
        <div className="bg-green-100 border border-green-400 rounded-lg p-3 mt-3">
          <p className="text-green-900 font-semibold">Seller Product</p>
          <a
            href={post.product_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline text-sm"
          >
            {post.product_url}
          </a>
        </div>
      )}
      {/* <div className="flex justify-between items-center pt-2">
        <div className="flex items-center gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-2 bg-gray-600 px-2 py-[5px] rounded-xl">
            <BsChatSquareDotsFill className="text-white" />
            <span className="text-white">4.2k</span>
          </div>
          <div className="flex items-center gap-1">
            <FaRegEye className="text-gray-500 text-xl" />
            <span>120 Views</span>
          </div>
        </div>

        <button className="">
          <img
            src="/image/sharebuttoncontainer.png"
            alt="share"
            className="w-[110px] h-[35px]"
          />
        </button>
      </div> */}
      {/* Footer */}
      <div className="flex justify-between items-center pt-2">
        <div className="flex items-center gap-4 text-sm text-gray-600">
          {/* Comments */}
          <div className="flex items-center gap-2 bg-gray-600 px-2 py-[5px] rounded-xl">
            <BsChatSquareDotsFill className="text-white" />
            <span className="text-white">{post?.commentCount || 0}</span>
          </div>
          {/* Views (your API doesn’t return viewCount, fallback to 0) */}
          {/* <div className="flex items-center gap-1">
            <FaRegEye className="text-gray-500 text-xl" />
            <span>{post?.viewCount || "0"} Views</span>
          </div> */}
        </div>
        {/* Share */}
        {/* <button
          className="flex items-center space-x-1 text-[#fff] share-post-cta"
          onClick={() => handleShareClick(post.share_text)} // ✅ pass share_text
        >
          <img src={shareIcon} alt="Share" />
          &nbsp;Share
        </button>
        <ShareModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          shareUrl={currentPostUrl}
        /> */}

        <PostEditModal
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          post={post}
          sellerId={profiledate?.id}
          refreshPosts={() => window.location.reload()}
        />
        {/* ✅ Post Popup */}
        <PostPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          selectedPost={selectedPost}
          comments={comments}
          fetchComments={fetchComments}
        />
      </div>
    </div>
  );
}
